import { appOnlineStatusReducer } from "MainApp/features/OnlineOffline/reducer";
import hashTagsReducer from "MainApp/features/HashTagPopup/hashTagSlice";
import logoutReducer from "MainApp/features/Login/logoutSlice";


export default {
    appOnlineStatus: appOnlineStatusReducer,
    hashTags: hashTagsReducer,
    logout: logoutReducer
}